// React imports
import React from 'react';

// React based imports
import { Switch, Route, Redirect } from 'react-router-dom';

// Third-party imports

// Project file imports
import Customers from './views/customers';
import AddCustomer from './views/customers/AddCustomer'
import InvoiceList from './views/invoices/InvoiceList';
import AddInvoice from './views/invoices/AddInvoice';
import ItemList from './views/items/ItemList';
import ItemForm from './views/items/ItemForm';
import PaymentReceived from './views/payments/PaymentReceived';
import RecordPayment from './views/payments/RecordPayment';


export interface MenuRoute {
    path: string;
    icon: JSX.Element;
    text: string;
}

export const Routes = (props: any): React.ReactElement => {
    const { match , filterYear} = props;
    return (
        <Switch>
            <Route path={`${match.path}/`} exact render={(props) => <Redirect to="/dashboard/customers" />}/>
            <Route path={`${match.path}/customer/new`} exact render={(props) => <AddCustomer {...props} filterYear={filterYear}/>}/>
            <Route path={`${match.path}/customer/:id?`} exact render={(props) => <AddCustomer {...props} filterYear={filterYear}/>}/>
            <Route path={`${match.path}/customers/:id?`} exact render={(props) => <Customers {...props} filterYear={filterYear}/>}/>
            <Route path={`${match.path}/invoices`} exact render={(props) => <InvoiceList {...props} filterYear={filterYear}/>}/>
            <Route path={`${match.path}/invoices/:id?`} render={(props) => <AddInvoice {...props} filterYear={filterYear}/>}/>
            <Route path={`${match.path}/items`} exact render={(props) => <ItemList {...props} filterYear={filterYear}/>}/>
            <Route path={`${match.path}/items/:id?`} render={(props) => <ItemForm {...props} filterYear={filterYear}/>}/>
            <Route path={`${match.path}/payments`} exact render={(props) => <PaymentReceived {...props} filterYear={filterYear}/>}/>
            <Route path={`${match.path}/payments/:id?`} render={(props) => <RecordPayment {...props} filterYear={filterYear}/>}/>
            {/* <Route path={`${match.path}/expense`} exact render={(props) => <ExpenseList {...props} />}/> */}
            {/* <Route path={`${match.path}/expense/:id?`} render={(props) => <AddExpense {...props} />}/> */}
        </Switch>
    );
}

export const routesArray: MenuRoute[] = [
    // {
    //     path: '/dashboard',
    //     // component: Items,
    //     icon: <img src="/img/dashboard.png" alt="icon"/>,
    //     text: 'Dashboard'
    // },
    {
        path: '/dashboard/customers',
        // component: Items,
        icon: <img src="/img/customer.png" alt="icon"/>,
        text: 'Customers'
    },
    {
        path: '/dashboard/invoices',
        // component: invoices,
        icon: <img src="/img/invoice.png" alt="icon"/>,
        text: 'Invoices'
    },
    {
        path: '/dashboard/items',
        // component: Items,
        icon: <img src="/img/items.png" alt="icon"/>,
        text: 'Items'
    },
    {
        path: '/dashboard/payments',
        // component: payments,
        icon: <img src="/img/payment.png" alt="icon"/>,
        text: 'Payments'
    },
    // {
    //     path: '/dashboard/expense',
    //     // component: expense,
    //     icon: <img src="/img/expense.png" alt="icon"/>,
    //     text: 'Expense'
    // },
];